import type { OtcLayerAmendmentType, OtcRollDirection } from "@/lib/api/otc";

export type AmendmentTypeChoice =
  | "exit"
  | "expired"
  | "roll_up"
  | "roll_down"
  | "futures_roll"
  | "basis_roll"
  | "otc_roll"
  | "contract_legs_change"
  | "split";

export interface AmendmentTypeOption {
  value: AmendmentTypeChoice;
  label: string;
  amendment_type: OtcLayerAmendmentType;
  roll_direction?: OtcRollDirection;
}

export const AMENDMENT_TYPE_OPTIONS: AmendmentTypeOption[] = [
  { value: "exit", label: "Exit", amendment_type: "exit" },
  { value: "expired", label: "Expired", amendment_type: "expired" },
  // { value: "roll_up", label: "Roll Up", amendment_type: "roll", roll_direction: "up" },
  // { value: "roll_down", label: "Roll Down", amendment_type: "roll", roll_direction: "down" },
  { value: "futures_roll", label: "Futures Roll", amendment_type: "futures_roll" },
  { value: "basis_roll", label: "Basis Roll", amendment_type: "basis_roll" },
  { value: "otc_roll", label: "OTC Roll", amendment_type: "otc_roll" },
  { value: "contract_legs_change", label: "Contract Legs Change", amendment_type: "contract_legs_change" },
  { value: "split", label: "Split", amendment_type: "split" },
];

const ADDITIONAL_AMENDMENT_TYPE_LABELS: Partial<Record<OtcLayerAmendmentType, string>> = {
  contract_type_change: "Contract Type Change",
  roll: "Roll",
};

export function getAmendmentTypeDisplay(amendmentType: string | null | undefined): string {
  if (!amendmentType) return "Initial";

  const option = AMENDMENT_TYPE_OPTIONS.find(
    (item: AmendmentTypeOption): boolean => item.amendment_type === amendmentType,
  );
  if (option) return option.label;

  const knownLabel = ADDITIONAL_AMENDMENT_TYPE_LABELS[amendmentType as OtcLayerAmendmentType];
  if (knownLabel) return knownLabel;

  return amendmentType
    .split("_")
    .filter((part: string): boolean => part.length > 0)
    .map((part: string): string => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");
}
